import React from 'react';

import './UserExperienceEducationCallToAction.scss';
import SVGFromCloudinary from '../../Elements/SVGFromCloudinary/SVGFromCloudinary';

export default class UserExperienceEducationCallToAction extends React.PureComponent {
    render() {
        return (
            <div className="component-Users-UserExperienceEducationCallToAction">
                <div className={'text-display'}>
                    <p className={'call-to-action-title'}>
                        Add your experience and education.
                    </p>
                    <p className={'call-to-action-message'}>
                        You’ll stand out to recruiters and increase your
                        visibility to other members of Fairygodboss.
                    </p>
                </div>
                <SVGFromCloudinary cloudinaryID={'/v1/SVGs/Group_7.svg'} />
            </div>
        );
    }
}
